module.exports = __webpack_public_path__ + "static/media/instagram-logo.99bfe16b.svg";